'use client'

import { useSyncExternalStore } from 'react'

function subscribePointer(onChange: () => void) {
  const query = window.matchMedia('(pointer: coarse)')

  query.addEventListener('change', onChange)

  return () => query.removeEventListener('change', onChange)
}

function coarsePointer() {
  return window.matchMedia('(pointer: coarse)').matches
}

function serverPointer() {
  return false
}

export function useMobileSheet(enabled: boolean) {
  return useSyncExternalStore(subscribePointer, coarsePointer, serverPointer) && enabled
}
